export default __webpack_public_path__ + "static/media/0x74946a114ca2b26267983ef51ad8664cabde4034.431d2d86.webp";